export function notifySuccess(message) {
    window.WatchkeeperOnline.notifySuccess(message);
}
export function notifyError(message) {
    window.WatchkeeperOnline.notifyError(message);
}
